import { render, staticRenderFns } from "./PortfolioCardMobile.vue?vue&type=template&id=374c39a1&scoped=true&"
import script from "./PortfolioCardMobile.vue?vue&type=script&lang=js&"
export * from "./PortfolioCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCardMobile.vue?vue&type=style&index=0&id=374c39a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c39a1",
  null
  
)

export default component.exports